import { createContext, useContext, useState, PropsWithChildren } from 'react';

export type ViewMode = 'admin' | 'enduser';

export interface ViewModeContextData {
  viewMode: ViewMode;
  setViewMode: (mode: ViewMode) => void;
  toggleViewMode: () => void;
}

const ViewModeContext = createContext<ViewModeContextData | undefined>(
  undefined,
);

export function ViewModeProvider({ children }: PropsWithChildren) {
  const [viewMode, setViewMode] = useState<ViewMode>('admin');

  const toggleViewMode = () => {
    setViewMode((current) => (current === 'admin' ? 'enduser' : 'admin'));
  };

  return (
    <ViewModeContext.Provider
      value={{
        viewMode,
        setViewMode,
        toggleViewMode,
      }}
    >
      {children}
    </ViewModeContext.Provider>
  );
}

export function useViewMode() {
  const context = useContext(ViewModeContext);
  if (context === undefined) {
    throw new Error('useViewMode must be used within a ViewModeProvider');
  }
  return context;
}
